import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import Button from '../../../core/modules/common/components/Button';
import Modal from '../../../core/modules/common/components/Modal';

// eslint-disable-next-line react/prefer-stateless-function
class DeleteModal extends Component {
  render() {
    const {
      deleteSelection,
      onCloseModal,
      headerFormattedMessageId,
    } = this.props;

    return (
      <Modal
        header={
          <FormattedMessage
            id={headerFormattedMessageId}
            tagName="h5"
          />
        }
        closeOnOutsideClick
        onClose={this.props.onCloseModal}
      >
        <div className="operator-form">
          <div className="button-container">
            <Button
              text="app.button.cancel"
              onClick={onCloseModal}
            />
            <Button
              type="submit"
              text="app.button.yes"
              onClick={deleteSelection}
            />
          </div>
        </div>
      </Modal>
    );
  }
}

DeleteModal.propTypes = {
  onCloseModal: PropTypes.func.isRequired,
  deleteSelection: PropTypes.func.isRequired,
  headerFormattedMessageId: PropTypes.string.isRequired,
};

export default (DeleteModal);
